import { useQuery } from '@apollo/client';
import { graphql } from 'src/generated';
import { type TableViewDetailsFragment } from 'src/generated/graphql';
import { useBoardContext } from '../BoardContext';
import { useBoardTableContext } from '../TablePage/BoardTableContextProvider';

export const tableViewRowsDoc = graphql(`
  query TableViewData($input: QueryTableViewInput!) {
    tableView(input: $input) {
      ...tableViewDetails
      
      rows @nonreactive {
        ...tableRow
      }
    }
  }
`);

export type TableViewQueryData = TableViewDetailsFragment;

export const useTableViewQuery = (viewId: string) => {
  const { board } = useBoardContext();
  const { table } = useBoardTableContext();

  const { data, loading } = useQuery(tableViewRowsDoc, {
    refetchWritePolicy: 'overwrite',
    fetchPolicy: 'cache-first',
    variables: {
      input: {
        boardId: board._id,
        tableId: table._id,
        viewId,
      },
    },
  });

  return {
    tableView: data?.tableView,
    isTableViewLoading: loading,
  };
};
